import React from "react";
import ModalVideo from 'react-modal-video'
import 'react-modal-video/scss/modal-video.scss';

const VideoPlay = (props)  => {
//    console.log("propssss",props)
    return (
        <React.Fragment>
         <ModalVideo 
            channel='youtube' 
            autoplay 
            isOpen={props.isOpen} 
            videoId={props.videoId}
            autoplay={1}
            onClose={ e => props.isCloseFunction(false)}
         />

    {/* <ReactPlayer
      url={props.url}
      playing={props.playing}
      volume={props.volume}
      onReady={() => console.log("ready now")}
      onClose={ e => props.isCloseFunction(false)}
    /> */}
    {
        //console.log("===url==",props.url_id)
    }
          {/* <Vimeo
            video={props.url_id}
            width={640}
            height={480}
            autoplay
            volume={props.volume}
            // paused={props.paused}
            onPause={()=> props.isCloseFunction(false)}
            onPlay={props.playing}
          /> */}

        </React.Fragment>
    )
};

export default VideoPlay;